<template>
  <div :class="infoBlockStyle">
    <div :class="$style.infoBlockIcon">
      <app-svg-icon name="ic_info"
                    :class="$style.infoIcon"/>
    </div>
    <p :class="$style.infoBlockText">
      <slot />
    </p>
  </div>
</template>

<script>
export default {
  props: {
    iconTop: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    infoBlockStyle() {
      if (this.iconTop) {
        return [this.$style.infoBlock, this.$style.iconTop];
      }

      if (this.small) {
        return [this.$style.infoBlock, this.$style.infoBlockSmall];
      }

      return this.$style.infoBlock;
    },
  },
};
</script>

<style lang="scss" module>
@import "@/styles/variables.scss";

.infoBlock {
  border: $info-block-border;
  border-radius: 4px;
  background-color: $info-block-color;
  padding: 15px 24px;
  display: flex;
  align-items: center;

  &.iconTop {
    align-items: flex-start;
  }

  .infoBlockIcon {
    max-width: 30px;
    max-height: 30px;
    margin-right: 24px;
    .infoIcon {
      max-width: 30px;
      max-height: 30px;
    }
  }
  .infoBlockText {
    flex-grow: 1;
    margin-bottom: 0;
    text-align: left;

    p:last-child {
      margin-bottom: 0;
    }
  }
}

.infoBlock.infoBlockSmall {
  padding: 4px 10px;
  margin-bottom: 10px;

  .infoBlockIcon {
    max-width: 20px;
    max-height: 20px;
    margin-right: 14px;
    .infoIcon {
      max-width: 20px;
      max-height: 20px;
    }
  }

  .infoBlockText {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}
</style>
